//统一请求方法，that当前实例,url请求地址,param请求参数,resolve成功时调用方法,reject错误时调用方法
async function _requestData(that,url,param,requestType='post',resolve,reject){
    var _this=that
    try{
        var res={}
        switch(requestType){
            case "post":
                res = await _this.$http.post(url,param)
                break;
            case "get":
                res = await _this.$http.get(url,param)
                break;
            default:
                res = await _this.$http.post(url,param)
                break;
        }
        res={data:res}
        if(res.code=="200"){
            if(resolve) resolve()
        }
        else{
            if(reject) reject()
        }
    }
    catch(error){
        _this.$message.error(error)
    }
    finally{
        return res
    }
}
//产品数据 param:{productkey:"",keyword:""}
async function _getProductData(that,param,resolve, reject){
    var _this=that
let _parms=JSON.parse((param))
  _parms['cSystemCode']='节水灌溉';

//console.log('  param[\'cSystemCode\']',  typeof (param));
//  param.cSystemCode='节水灌溉'
 // param.push({'cSystemCode':'节水灌溉'});
 console.log('  param[\'cSystemCode\']',  JSON.stringify(_parms));
    const {data:res} = await _this.$http.post('WLWProduct/List?cSystemCode=节水灌溉',JSON.stringify(_parms))
    if(res.code=="200"){
      _this.$store.commit('setProducts',res.obj.list)
      if(resolve) resolve()
      return res
    }
    else{
      //_this.$message.error(res.message)
      if(reject) reject()
      return null
    }
}
//海康token



async function _getThingModels(that,param,resolve, reject){
    var _this=that
    const {data:res} = await _this.$http.post('WLWProduct/WLWProductThingModelList?cSystemCode=节水灌溉',param)
    if(res.code=="200"){
      res.obj.list.forEach(element => {
        // element.propertiesR.forEach(item=>{
        //   //item.cIcon =item.cIcon!=null?require(item.cIcon):"../img/guangzhanduIcon.png"
        //   item.cIcon ="static/img/icon/guangzhanduIcon.png"
        // })
        if(element.propertiesW!=null){
            element.propertiesW.forEach(item=>{
                if(item.dataType=="INT"){
                    if(Number(item.dataSpecs.max)-Number(item.dataSpecs.step)==Number(item.dataSpecs.min)){
                        item.dataType="BOOL"
                    }
                }
            })
        }
      })
      _this.$store.commit('setThingModels',res.obj.list)
      if(resolve) resolve()
      return res
    }
    else{
      //_this.$message.error(res.message)
      if(reject) reject()
      return null
    }
}

//设备数据 param:{productkey:"",devicename:"",keyword:""}
async function _getDevices(that,param,resolve, reject){
    var _this=that
  param.cSystemCode='节水灌溉'
    const {data:res} = await _this.$http.post('WLWDevice/List',param)
    if(res.code=="200"){
       // _this.$store.commit('setDevices',res.obj.list)
        if(resolve) resolve()
        return res
    }
    else{
        //_this.$message.error(res.message)
        if(reject) reject()
        return null
    }
}
//设备属性数据 param:{productkey:"",devicename:"",limit:2}  获得最新2条数据，limit为0获取所有
async function _getDevicePropData(that,param,resolve, reject){
    var _this=that
    const {data:res} = await _this.$http.post('WLWDevice/DevicePropertyDataList',param)
    if(res.code=="200"){
        if(resolve) resolve()
        return res
    }
    else{
        //_this.$message.error(res.message)
        if(reject) reject()
        return null
    }
}
async function _getDevicePropDataTop(that,param,resolve, reject){
  var _this=that
  const {data:res} = await _this.$http.post('WLWDevice/DevicePropertyData',param)
  if(res.code=="200"){
    if(resolve) resolve()
    return res
  }
  else{

    if(reject) reject()
    return null
  }
}

//设备消息数据 param:{productkey:"",devicename:"",limit:2}  获得最新2条数据，limit为0获取所有
async function _getDeviceNoticeData(that,param,resolve, reject){
    var _this=that
  param.cSystemCode='节水灌溉'
    const {data:res} = await _this.$http.post('WLWDevice/DeviceStatusDataList',param)
    if(res.code=="200"){
        if(resolve) resolve()
        return res
    }
    else{
        //_this.$message.error(res.message)
        if(reject) reject()
        return null
    }
}
async function _getAllUser(that,param,resolve,reject){
  var _this=that;
  param.cSystemCode='节水灌溉';
  const {data:res} = await _this.$http.post('User/GetEntUserList',param)
  if(res.code=="200"){
    if(resolve) resolve()
    return res
  }
  else{
    //_this.$message.error(res.message)
    if(reject) reject()
    return null
  }

}
//设备事件数据 param:{productkey:"",devicename:"",limit:2}  获得最新2条数据，limit为0获取所有
async function _getDeviceEventData(that,param,resolve, reject){
    var _this=that
    const {data:res} = await _this.$http.post('WLWDevice/DeviceEventDataList',param)
    if(res.code=="200"){
        if(resolve) resolve()
        return res
    }
    else{
        //_this.$message.error(res.message)
        if(reject) reject()
        return null
    }
}

//设备服务数据 param:{productkey:"",devicename:"",limit:2}  获得最新2条数据，limit为0获取所有
async function _getDeviceServiceData(that,param,resolve, reject){
    var _this=that
    const {data:res} = await _this.$http.post('WLWDevice/DeviceServiceDataList',param)
    if(res.code=="200"){
        if(resolve) resolve()
        return res
    }
    else{
        //_this.$message.error(res.message)
        if(reject) reject()
        return null
    }
}

//项目数据 param:{cEntID:"",keyword:""}
async function _getEntPlatFormData(that,param,resolve, reject){
    var url="EntPlatformInfo/List";
  param.cSystemCode='节水灌溉';
    var res = _requestData(that,url,param,resolve, reject)
    return res
}

export {
    _getProductData,
    _getThingModels,
    _getDevices,
    _getDevicePropData,
    _getDeviceNoticeData,
    _getEntPlatFormData,
    _getDeviceEventData,
    _getDeviceServiceData,
  _getDevicePropDataTop,
  _getAllUser


}
